export default "__VITE_ASSET__o7Lydp3A__"